/** Tips in the order a new user sees them; the popup then continues one tip a day. */
export const TIP_IDS = ['welcome', 'examples', 'layers', 'optimize', 'market', 'help'] as const;
export type TipId = (typeof TIP_IDS)[number];

/** Where the popup starts: new users with the welcome tip, returning users after the last one they saw. */
export const startTipIndex = (tipsSeen: number | undefined, total: number = TIP_IDS.length): number =>
  (((tipsSeen ?? 0) % total) + total) % total;

/** `tipsSeen` after a session in which the user looked at `viewed` distinct tips (always at least one). */
export const tipsSeenAfter = (tipsSeen: number | undefined, viewed: number): number =>
  (tipsSeen ?? 0) + Math.max(1, viewed);

/** Local calendar day, so "once a day" follows the user's clock. */
export const localDayKey = (date: Date = new Date()): string =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

/** The popup opens by itself at most once a day, until the user turns the tips off. */
export const shouldAutoOpenTips = (options: {
  enabled: boolean;
  hidden: boolean | undefined;
  lastShownOn: string | null;
  today: string;
}): boolean => options.enabled && !options.hidden && options.lastShownOn !== options.today;
